class InfiniteScroll {
  constructor() {
    this.sentinel = document.getElementById('InfiniteScrollSentinel');
    this.grid = document.getElementById('product-grid');

    console.log('[InfiniteScroll] sentinel found:', !!this.sentinel);
    console.log('[InfiniteScroll] grid found:', !!this.grid);

    if (!this.sentinel) {
      console.warn('[InfiniteScroll] No sentinel — pagination.pages might be 1 (only one page of products), or the sentinel div did not render.');
      return;
    }
    if (!this.grid) {
      console.warn('[InfiniteScroll] No #product-grid found.');
      return;
    }

    console.log('[InfiniteScroll] next-url:', this.sentinel.dataset.nextUrl);

    this.loading = false;

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: '600px',
      threshold: 0,
    });
    this.observer.observe(this.sentinel);
    console.log('[InfiniteScroll] Observer attached.');
  }

  onIntersect(entries) {
    console.log('[InfiniteScroll] intersecting:', entries[0].isIntersecting);
    if (entries[0].isIntersecting && !this.loading) {
      this.loadNextPage();
    }
  }

  async loadNextPage() {
    const nextUrl = this.sentinel.dataset.nextUrl;
    if (!nextUrl) {
      console.log('[InfiniteScroll] No next URL — stopping.');
      this.observer.disconnect();
      return;
    }

    console.log('[InfiniteScroll] Fetching:', nextUrl);
    this.loading = true;
    const loader = document.getElementById('InfiniteScrollLoader');
    if (loader) loader.style.display = 'block';

    try {
      const response = await fetch(nextUrl);
      console.log('[InfiniteScroll] Response status:', response.status);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newItems = doc.getElementById('product-grid');
      const newSentinel = doc.getElementById('InfiniteScrollSentinel');

      console.log('[InfiniteScroll] New items found:', !!newItems, 'New sentinel found:', !!newSentinel);

      if (newItems) {
        this.grid.insertAdjacentHTML('beforeend', newItems.innerHTML);
        console.log('[InfiniteScroll] Products appended.');
      }

      if (newSentinel && newSentinel.dataset.nextUrl) {
        this.sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
        console.log('[InfiniteScroll] Updated next-url to:', newSentinel.dataset.nextUrl);
      } else {
        this.sentinel.dataset.nextUrl = '';
        this.observer.disconnect();
        console.log('[InfiniteScroll] No more pages. Stopping.');
      }
    } catch (err) {
      console.error('[InfiniteScroll] Fetch failed:', err);
    } finally {
      this.loading = false;
      if (loader) loader.style.display = 'none';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('[InfiniteScroll] DOM ready, initializing...');
  new InfiniteScroll();
});